import { getEnv } from "../../../../utils/env"

const cached = {}

export const getCustomHeaders = () => {
  if (Object.keys(cached).length === 0) {
    const cHeaders = getEnv("CUSTOM_HEADERS")
    const list = cHeaders.split(";")
    for (const item of list) {
      // Split is not good for this
      const matches = item.match(/^(.*?):(.*)$/)
      if (matches) {
        cached[matches[1]] = decodeURIComponent(matches[2])
      }
    }
  }
  return cached
}
